module.exports = __webpack_public_path__ + "images/facade-plan-2-e50fe3c0d89b8befe9066f5cd521da93.jpg";